import { ref, onMounted, onUnmounted } from "vue";
import api from "@/services/api";
import { getLiveEvents } from "@/utils/eventStatus";

const POLL_INTERVAL_MS = 60_000;

export function useLiveEvents() {
  const liveEvents = ref([]);
  const loading = ref(false);

  const refreshLiveEvents = async () => {
    try {
      loading.value = true;
      const token = localStorage.getItem("token");
      if (!token) {
        liveEvents.value = [];
        return;
      }

      const response = await api.get("/api/events");
      if (response.data.success) {
        const events = response.data.data.events || [];
        liveEvents.value = getLiveEvents(events);
      }
    } catch (error) {
      console.error("Failed to fetch live events:", error);
    } finally {
      loading.value = false;
    }
  };

  let pollInterval = null;

  const handleWindowFocus = () => {
    refreshLiveEvents();
  };

  onMounted(() => {
    refreshLiveEvents();
    pollInterval = setInterval(refreshLiveEvents, POLL_INTERVAL_MS);
    window.addEventListener("focus", handleWindowFocus);
  });

  onUnmounted(() => {
    if (pollInterval) clearInterval(pollInterval);
    window.removeEventListener("focus", handleWindowFocus);
  });

  return {
    liveEvents,
    loading,
    refreshLiveEvents
  };
}
